"use strict";

const Limit = require('./Limit');

const Map = require('./Map');

function deferred() {
  let resolve, reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  promise.resolve = resolve;
  promise.reject = reject;
  return promise;
}

module.exports = {
  all: Limit.all,
  limit: Limit.limit,
  map: Map.map,
  mapLimit: Map.mapLimit,
  deferred
};